/**
 * 获取基础合约代码（小写）
 * @param contractCode 合约代码
 * @returns 处理后的小写合约代码
 */
export const getBaseContractCode = (contractCode: string): string => {
  if (!contractCode) {
    return contractCode
  }

  const pattern = /_\d+$/
  return contractCode.replace(pattern, '').toLowerCase()
}

// 使用示例：
// getBaseContractCode('BTC_USDT_20240321') => 'btc_usdt'
// getBaseContractCode('ETH_123') => 'eth'
// getBaseContractCode('') => ''

/**
 * 获取交割合约代码
 * @param contractCode 合约代码
 * @param contractType 合约类型
 * @returns 交割合约代码
 */
export const getDeliverContractCode = (contractCode: string, contractType: string): string => {
  return `${getBaseContractCode(contractCode)}_${contractType}_d`
}

// 使用示例：
// getDeliverContractCode('BTC_USDT_20240321', 'perpetual') => 'btc_usdt_perpetual_d'
// getDeliverContractCode('ETH_123', 'deliver') => 'eth_deliver_d'
// getDeliverContractCode('ETH_123', 'perpetual') => 'eth_perpetual_d'

// 稳定币合约
export const StableCoinBase = ['usdt', 'usdc'] as const
export type TStableCoinBase = (typeof StableCoinBase)[number]

// 获取是否是稳定币合约
export const getIsStableCoinBase = (base: string | undefined): boolean => {
  if (!base) {
    return false
  }
  return StableCoinBase.includes(base.toLowerCase() as TStableCoinBase)
}
